module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("ABBREVIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "fm-head"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIMARY")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURCES")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Chr")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Chronicles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Cor")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Corinthians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 En.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Enoch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Esd")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Esdras")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Kgs")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Kings")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Macc")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rule of the Community")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Sam")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Samuel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Thess")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Thessalonians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Bar.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Baruch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Chr")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Chronicles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Esd")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Esdras")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Kgs")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Kings")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Macc")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Pet")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Peter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("3 Macc")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("3 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4 Macc")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Abr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De Abrahamo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Add Esth")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Additions to Esther")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Amic.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("De amicitia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Am. prol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', [_vm._v("De amore prolis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Andr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Terence, "), _c('em', [_vm._v("Andria")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Antiquitates judaicae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anth.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Stobaeus, "), _c('em', [_vm._v("Anthologium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Apoc. Zeph.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Apocalypse of Zephaniah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("b.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Babylonian Talmud")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bab. Theod.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Babylonian Theodicy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bar")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baruch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("B. Bat.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baba Batra")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bel")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bel and the Dragon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bell.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Bellum judaicum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ber.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Berakhot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibl. hist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Diodorus, "), _c('em', [_vm._v("Bibliotheca historica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bis acc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lucian, "), _c('em', [_vm._v("Bis accusatus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BM")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Berlin Museum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("B. Me"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ṣ")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baba Me"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ṣ")]), _vm._v("i"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("a")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("C. Ap.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Contra Apionem")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Carm. aur.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Carmen aureum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Damascus Document")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Claud.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Suetonius, "), _c('em', [_vm._v("Claudius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Col")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Colossians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Conj. praec.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', [_vm._v("Conjugalia praecepta")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Coun. Wis.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Counsels of Wisdom")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dan")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Daniel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Decal.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De decalogo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Demon.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isocrates, "), _c('em', [_vm._v("Ad Demonicum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Deus")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("Quod Deus sit immutabilis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deuteronomy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Diatr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epictetus, "), _c('em', [_vm._v("Diatribai")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Did.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Didache")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dis.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cato, "), _c('em', [_vm._v("Distichs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Div.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("De divinatione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ebr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De ebrietate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("El.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Propertius, "), _c('em', [_vm._v("Elegiae")]), _vm._v("; Sophocles, "), _c('em', [_vm._v("Elektra")]), _vm._v("; Theognis, "), _c('em', [_vm._v("Elegiae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ench.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epictetus, "), _c('em', [_vm._v("Enchiridion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Martial, "), _c('em', [_vm._v("Epistulae")]), _vm._v("; Pliny, "), _c('em', [_vm._v("Epistulae")]), _vm._v("; Seneca, "), _c('em', [_vm._v("Epistulae")]), _vm._v("; Ps.-Socratics, "), _c('em', [_vm._v("Epistulae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eph")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ephesians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ep Jer")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epistle of Jeremiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Erub.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Erubin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Esth")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Esther")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Eth. nic.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aristotle, "), _c('em', [_vm._v("Ethica nicomachea")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exodus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezek")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezekiel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Fab.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Babrius, "), _c('em', [_vm._v("Fabulae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gen")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Genesis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gen. Rab.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Genesis Rabbah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gnom. Democr.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gnomologium Democrateum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gnom. Epict.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gnomologium Epictetum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hab")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Habakkuk")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hag")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Haggai")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hag.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hagigah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Heb")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hebrews")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hel. Syn. Pr.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hellenistic Synagogal Prayers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Her.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("Quis rerum divinarum heres sit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hos")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hosea")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hypoth.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("Hypothetica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Il.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Homer, "), _c('em', [_vm._v("Iliad")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Inscr. Ashur.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Inscription of Ashurbanipal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inst.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Quintilian, "), _c('em', [_vm._v("Institutio oratoria")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Amen.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Amenemope")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Anii")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Anii")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Ankh.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Ankhsheshonqy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Duauf")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Duauf")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Kag.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Kagemni")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Mer.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Merikare")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Ptah.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Ptahhotep")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Shub.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Shube-Awilim")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instr. Shur.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Instruction of Shuruppak")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isa")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isaiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jas")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jdt")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judith")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jer")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jeremiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jos. Asen.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joseph and Aseneth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josh")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joshua")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jub.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jubilees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judg")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ketub.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ketubbot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LAB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Liber antiquitatum biblicarum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lam")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lamentations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plato, "), _c('em', [_vm._v("Leges")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Leocr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lycurgus, "), _c('em', [_vm._v("Against Leocrates")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Let. Aris.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Letter of Aristeas")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Leviticus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lib. ed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', [_vm._v("De liberis educandis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Liv. Pro.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lives of the Prophets")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lud. bēl nēm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ludlul bēl nēmeqi")]), _vm._v(" (The Poem of the Righteous Sufferer)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lyc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', [_vm._v("Lycurgus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("m.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mishnah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mal")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Malachi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Marc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Porphyry, "), _c('em', [_vm._v("Ad Marcellam")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Matt")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Matthew")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Med.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Marcus Aurelius, "), _c('em', [_vm._v("Meditationes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Migr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De migratione Abrahami")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mon.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cato, "), _c('em', [_vm._v("Monostichoi")]), _vm._v("; Menander, "), _c('em', [_vm._v("Monostichoi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mos.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De vita Mosis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nah")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nahum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ned.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nedarim")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nehemiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Nic.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isocrates, "), _c('em', [_vm._v("Nicocles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Num")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Numbers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Oec.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Xenophon, "), _c('em', [_vm._v("Oeconomicus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Op.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hesiod, "), _c('em', [_vm._v("Opera et dies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Opif.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De opificio mundi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("P. Ana.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Papyrus Anastasi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("P. Beat.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Papyrus Beatty")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Phaedr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plato, "), _c('em', [_vm._v("Phaedrus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Philops.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lucian, "), _c('em', [_vm._v("Philopseudes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("P. Ins.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Papyrus Insinger")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pisc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lucian, "), _c('em', [_vm._v("Piscator")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("P. Lan.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Papyrus Lansing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("P. Louv.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Papyrus Louvre 2414")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aristotle, "), _c('em', [_vm._v("Politica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("pr.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("prologue")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Praem")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De praemiis et poenis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pr Azar")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prayer of Azariah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Princ. iner.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', [_vm._v("Ad principem ineruditum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pr Man")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prayer of Manasseh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prov")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Proverbs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Prov.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Seneca, "), _c('em', [_vm._v("De providentia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ps.-Phoc.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pseudo-Phocylides")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ps(s)")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Psalm(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pss. Sol.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Psalms of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qidd.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qiddushin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("QG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("Quaestiones et solutiones in Genesin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qoh")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qoheleth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quaest. conv.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', [_vm._v("Quaestionum convivialum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Rer. nat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lucretius, "), _c('em', [_vm._v("De rerum natura")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rev")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Revelation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rom")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Romans")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Šabb.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Šabbat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sacr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De sacrificiis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sanh.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sanhedrin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Juvenal, "), _c('em', [_vm._v("Satirae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sent.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Clitarchus, "), _c('em', [_vm._v("Sententiae")]), _vm._v("; Publilius, "), _c('em', [_vm._v("Sententiae")]), _vm._v("; Secundus, "), _c('em', [_vm._v("Sententiae")]), _vm._v("; Sextus, "), _c('em', [_vm._v("Sententiae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sept. Sap.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septem Sapientes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sg Three")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Song of the Three Young Men")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sib. Or.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sibylline Oracles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sir")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sirach/Ecclesiasticus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Somn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lucian, "), _c('em', [_vm._v("Somnium")]), _vm._v("; Philo, "), _c('em', [_vm._v("De somniis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Song")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Song of Songs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Spec.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De specialibus legibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sum. Prov. Coll.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sumerian Proverb Collection")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sus")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Susanna")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Symp.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plato, "), _c('em', [_vm._v("Symposium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Syr. Men.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Syriac Menander")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Ash.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Asher")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Teach. Silv.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Teachings of Silvanus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Gad")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Gad")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Isaac")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Isaac")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Iss.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Issachar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Job")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Job")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Jos.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Joseph")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Jud.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Judah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Levi")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Levi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Naph.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Naphtali")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tob")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tobit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Reub.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Reuben")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Sol.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. Zeb.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Testament of Zebulon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Virt.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', [_vm._v("De virtutibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Virt. prof.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', [_vm._v("Quomodo quis suos in virtute sentiat profectus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vit.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Suetonius, "), _c('em', [_vm._v("Vitellius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vit. phil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Diogenes Laertius, "), _c('em', [_vm._v("Vitae philosophorum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wis")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wisdom")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Yebam.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Yebamot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zech")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zechariah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zeph")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zephaniah")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-head"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECONDARY")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURCES")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AGJU")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Arbeiten zur Geschichte des antiken Judentums und des Urchristentums")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("American Journal of Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Association for Jewish Studies Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ATD")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Das Alte Testament Deutsch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeology Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBET")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beiträge zur biblischen Exegese und Theologie")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BJS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown Judaic Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BN")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische Notizen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BRLJ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brill Reference Library of Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBET")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Contributions to Biblical Exegesis and Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBQMS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Catholic Biblical Quarterly Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CEJL")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Commentaries on Early Jewish Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CHANE")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Culture and History of the Ancient Near East")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Classical Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DCLS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deuterocanonical and Cognate Literature Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Eerdmans Dictionary of the Bible")]), _vm._v(". Edited by David Noel Freedman. Grand Rapids: Eerdmans, 2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("EJL")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Early Judaism and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EncJud")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Encyclopedia Judaica")]), _vm._v(". Edited by Fred Skolnik and Michael Berenbaum. 2nd ed. 22 vols. Detroit: Macmillan Reference USA, 2007")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hen")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Henoch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HThKAT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herders Theologischer Kommentar zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HUCA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Union College Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of Judaism Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Pseudepigrapha")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSPSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Pseudepigrapha Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NEchtB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neue Echter Bibel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICOT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NovTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Novum Testamentum Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTOA")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Novum Testamentum et Orbis Antiquus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OBO")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Orbis Biblicus et Orientalis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OTE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Old Testament Essays")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PACS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo of Alexandria Commentary Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PIBA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Proceedings of the Irish Biblical Association")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RGRW")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Religions in the Graeco-Roman World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLEJL")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Early Jewish Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLMS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLTT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Texts and Translations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SPhA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Studia Philonica Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("StPB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia Post-biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TBN")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Themes in Biblical Narrative")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Texts and Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TSAJ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Texte und Studien zum antiken Judentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WAW")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Writings from the Ancient World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WLAW")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wisdom Literature from the Ancient World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZDPV")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift des deutschen Palästina-Vereins")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f39396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Abbreviations.vue
// module id = 72
// module chunks = 0